import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
interface RechartsPieChartProps {
  data: {
    label: string;
    value: number;
    color: string;
  }[];
  height?: number;
  donut?: boolean;
  innerRadius?: number;
  outerRadius?: number;
  tooltipFormatter?: (value: number, name: string) => [string, string];
}
const RechartsPieChart: React.FC<RechartsPieChartProps> = ({
  data,
  height = 300,
  donut = false,
  innerRadius = 0,
  outerRadius = 100,
  tooltipFormatter = (value, name) => [`${value}`, name]
}) => {
  return <ResponsiveContainer width="100%" height={height} data-id="element-207">
      <PieChart data-id="element-208">
        <Pie data={data} cx="50%" cy="50%" labelLine={false} innerRadius={donut ? innerRadius : 0} outerRadius={outerRadius} fill="#8884d8" dataKey="value" nameKey="label" data-id="element-209">
          {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-210" />)}
        </Pie>
        <Tooltip formatter={(value: any, name: string) => {
        const [formattedValue, formattedName] = tooltipFormatter(value, name);
        return [formattedValue, formattedName];
      }} contentStyle={{
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }} data-id="element-211" />
        <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{
        paddingTop: '20px'
      }} data-id="element-212" />
      </PieChart>
    </ResponsiveContainer>;
};
export default RechartsPieChart;